export class DetalleNegocioDTO {
  
    nombre_del_distribuidor : string 
    amount : string
    hubspot_owner_id : string
    dealname : string
    email: string
    phone: string
    tipodedocumento: string
    tipodepersona: string
    numeroidentificacion: string
    formattedAmount: string
    formattedDate: string | null
    age?: string

    constructor(data: any) {

        const dealProps = data.deal?.properties || {}
        const contactProps = data.contact?.properties || {}
        
        this.email = contactProps.email
        this.tipodepersona = contactProps.tipodepersona;

        this.tipodedocumento = contactProps.tipodedocumento
        this.numeroidentificacion = contactProps.numeroidentificacion
        
        const rawPhone = contactProps.phone;
        if (rawPhone && typeof rawPhone === 'string' && rawPhone.startsWith('+57')) {
        this.phone = rawPhone.slice(3);
        } else {
        this.phone = rawPhone;
        }
        
        this.age = contactProps.age

        this.dealname = dealProps.dealname
        this.nombre_del_distribuidor = dealProps.nombre_del_distribuidor
        this.amount = dealProps.amount
        this.hubspot_owner_id = dealProps.hubspot_owner_id
        
        this.amount = this.amount
        ? new Intl.NumberFormat("es-CO", {
            style: "currency",
            currency: "COP",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
            })
            .format(Number(this.amount))
            .replace("COP", "")
            .trim()
        : "";
        
        const dateToFormat = dealProps.createdate;
        this.formattedDate = dateToFormat
        ? new Date(dateToFormat)
            .toLocaleString("es-CO", {
                day: "2-digit",
                month: "2-digit",
                year: "2-digit",
            })
            .replace(",", "")
        : null;
    }
}
  